import { axios } from "~/plugins/request";
import { genSign } from "@/api/tim.js";
import tim from "~/plugins/tim";

const state = () => {
  return {
    currentUserProfile: {},
    isLogin: false,
    isSDKReady: false, // TIM SDK 是否 ready
    current: Date.now(), // 当前时间
    intervalID: 0
  };
};
const mutations = {
  updateCurrentUserProfile(state, userProfile) {
    state.currentUserProfile = userProfile;
  },
  toggleIsLogin(state, isLogin) {
    state.isLogin = typeof isLogin === "undefined" ? !state.isLogin : isLogin;
  },
  toggleIsSDKReady(state, isSDKReady) {
    state.isSDKReady =
      typeof isSDKReady === "undefined" ? !state.isSDKReady : isSDKReady;
  },
  reset(state) {
    Object.assign(state, {
      currentUserProfile: {},
      isLogin: false,
      isSDKReady: false // TIM SDK 是否 ready
    });
  },
  setIntervalId(state, intervalID) {
    state.intervalID = intervalID;
  },
  startComputeCurrent(state) {
    // state.intervalID = setInterval(() => {
    //   state.current = Date.now();
    // }, 1000);
    state.current = Date.now();
  },
  stopComputeCurrent(state) {
    clearInterval(state.intervalID);
    state.intervalID = 0;
  }
};

export const actions = {
  login(context, userID) {
    genSign(userID).then(res => {
      // tim
      //   .login({
      //     userID,
      //     userSig: res
      //   })
      //   .then(() => {
      //     console.log(res);
      //     context.commit("toggleIsLogin", true);

      //     let intervalID = setInterval(() => {
      //       context.commit("startComputeCurrent");
      //     }, 1000);
      //     context.commit("setIntervalId", intervalID);
      //   })
      //   .catch(imError => {
      //     if (imError.code === 2000) {
      //       window.$message.error(
      //         imError.message + ", 请检查是否正确填写了 SDKAPPID"
      //       );
      //     } else {
      //       window.$message.error(imError.message);
      //     }
      //   });
    });
  },
  logout(context) {
    // 若有当前会话，在退出登录时已读上报
    if (context.rootState.im.conversation.currentConversation.conversationID) {
      tim.setMessageRead({
        conversationID:
          context.rootState.im.conversation.currentConversation.conversationID
      });
    }
    tim.logout().then(() => {
      context.commit("toggleIsLogin");
      context.commit("stopComputeCurrent");
      context.commit("reset");
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
